import { CSSObject } from '@chakra-ui/react';

export const BadgeCountdown = (
  state: 'inprogress' | 'prior' | 'ended'
): CSSObject => ({
  bg: state === 'inprogress' ? 'yellow.400' : 'red.400',
  color: state === 'inprogress' ? 'yellow.900' : 'white',
});
